import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types"
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {
    getEmpleadosToCreateFaltaAPI,
    registrarFaltaAPI, validarRegistrarFaltaAPI,
} from "../../../../consumers/backendApisUrls";
import SpinnerLoading from "../../../../components/pageComponents/SpinnerLoading";
import {Div} from "../../../registroMaternidad/modales/components/Components";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import InputSearchAsync from "../../../../components/modalComponents/InputSearchAsync";
import Falta from "./Falta";
import {KEYS_FALTAS} from "./FaltasContantes";

const SECTION_NAME = "RegistrarFalta";

const RegistrarFalta = ({toggleModal, refreshPage}) => {
    const [formValuesFalta, setFormValuesFalta] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const [submitForm] = useSubmitForm();

    const [formValues, setFormValues] = useState({});
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [mensajeConfirmarRegistrar, setMensajeConfirmarRegistrar] = useState("");

    const [showModalConfirmarRegistrar, setShowModalConfirmarActualizar] = useState(false);

    const handleSubmit = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = validarRegistrarFaltaAPI();
        payload = getPayload();
        keys = KEYS_FALTAS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitValidarCallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleSubmitRegistrar = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = registrarFaltaAPI();
        payload = getPayload();
        keys = KEYS_FALTAS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitRegistrarCallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const successSubmitRegistrarCallback = async ({data}) => {
        setMensajeConfirmarRegistrar("");
        toggleConfirmarGuardar();
        toggleModal();
        await refreshPage();
    }

    const toggleConfirmarGuardar = () => {
        setShowModalConfirmarActualizar(!showModalConfirmarRegistrar);
    }

    const getPayload = () => {

        return {
            ...formValues,
            ...formValuesFalta
        }
    }

    const successSubmitValidarCallback = async ({data}) => {
        setMensajeConfirmarRegistrar(data?.Periodo);
        toggleConfirmarGuardar();
    }

    if (isLoading) return <SpinnerLoading/>

    return (
        <ModalForm
            titulo="Nuevo registro de Falta"
            width="1100px"
            showModal={toggleModal}
            isSubmitting={isSubmitting}
            saveButtonDisabled={isUploading || isSubmitting}
            onSubmit={handleSubmit}>

            <div className="displayFlexWrap">
              <Div col={8}>
                  <InputSearchAsync typeGet label='Empleado'  direction="column"
                                    api={getEmpleadosToCreateFaltaAPI} {...commonProps('IdEmpleado')} isRequired/>
              </Div>


                <Falta
                    SECTION_NAME={SECTION_NAME}
                    idEmpleado={formValues?.IdEmpleado}
                    formValuesFaltas={formValuesFalta}
                    setFormValuesFaltas={setFormValuesFalta}
                    KEYS={KEYS_FALTAS}
                    fromAdminPage={true}
                    isCreate={true}
                    isEditable={true}
                    handleSubmitRegistrar={handleSubmitRegistrar}
                    mensajeConfirmarRegistrar={mensajeConfirmarRegistrar}
                    showModalConfirmarRegistrar={showModalConfirmarRegistrar}
                    toggleConfirmarGuardar={toggleConfirmarGuardar}
                />
            </div>
        </ModalForm>
    );
}

RegistrarFalta.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default RegistrarFalta;